export interface ReportMetadata {
  id: string;
  name: string;
  description: string;
  category: ReportCategory;
  icon: string;
  filters: ReportFilter[];
  graphs: ReportGraph[];
  cacheable?: boolean;
}

export enum ReportCategory {
  All = "All",
  Sales = "Sales",
  Inventory = "Inventory",
  Finance = "Finance",
  Service = "Service"
}

export interface ReportSelectOption {
  value: string;
  label: string;
}

export interface ReportFilter {
  type?: string;
  name?: string;
  optional?: boolean;
  conditional?: ReportFilterConditional[];
  options?: ReportSelectOption[];
}

export interface ReportFilterConditional {
  field: string;
  value: string;
}

export interface ReportHeader {
  label: string;
  field: string;
  type: string;
}

export interface ReportData {
  headers: ReportHeader[];
  rows: { [key: string]: ReportCell }[];
}

export interface ReportCell {
  value: string;
  color: string;
}

export interface ReportGraphReferenceLine {
  label: string;
  value: number;
  color?: string;
}

export interface ReportGraph {
  type: string;
  title: string;
  xAxisField: string;
  includedFields: string[];
  xAxisFormat?: string;
  yAxisFormat?: string;
  xAxisFormatFunction?: (value: string) => string;
  yAxisFormatFunction?: (value: string) => string;
  referenceLines?: ReportGraphReferenceLine[];
}

